import handleResponse from './handle-response';
import $axios from '../services';

const ERROR_PAYLOAD = {
  success: false,
  data: { message: 'A server error occurred.' },
  message: 'Se produjo un error de comunicación con el servidor.',
};

const SESSION_EXPIRED_MESSAGE = 'Tu sesión expiró. Vuelve a iniciar sesión.';

// El cuerpo del error no siempre trae el shape `{ error: { errorMessage } }`:
// un 403 del API gateway, un 403 de CloudFront (HTML) o un corte de red llegan
// con otra forma, y leer a ciegas rompia la promesa dentro del catch.
const handleError = async (error) => {
  const { response } = error;
  if (!response) {
    return ERROR_PAYLOAD;
  }
  const { status, data } = response;
  const body = (data && typeof data === 'object') ? data : {};
  const errorData = (body.error && typeof body.error === 'object') ? body.error : {};
  const isExpired = status === 401 || status === 403;
  const message = errorData.errorMessage
    || body.message
    || (isExpired ? SESSION_EXPIRED_MESSAGE : ERROR_PAYLOAD.message);
  return {
    ...ERROR_PAYLOAD,
    status,
    data: errorData,
    message,
  };
};

const handleRequest = async (method, url, data = null, config = {}, headers = {}) => {
  try {
    const methods = {
      get: {
        ...config, method, url, params: { ...data }, headers,
      },
      post: {
        ...config, method, url, data, headers,
      },
      put: {
        ...config, method, url, data, headers,
      },
      delete: {
        ...config, method, url, headers,
      },
      default: {
        ...config, method, url,
      },
    };
    const requestConfig = methods[method] || methods.default;
    const response = await $axios(requestConfig);
    const payload = await handleResponse(response);
    return payload;
  } catch (error) {
    return handleError(error);
  }
};

export default handleRequest;
